export default __webpack_public_path__ + "static/media/ed2mit03tutorial00-Introduction-data-science-aanlytics-foundation-v03.pptx.653b06af.pdf";